import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'fgb-quiz-layout-page',
  templateUrl: './quiz-layout-page.component.html',
  styleUrl: './quiz-layout-page.component.scss',
})
export class QuizLayoutPageComponent {
  private router = inject(Router);

  get isLeaderboard(): boolean {
    return this.router.isActive('/games/trivia/leaderboard', {
      paths: 'exact',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
